import axios from 'axios';

/**
 * Implementation of API methods from the /web/multiclient endpoint.
 *
 * @category API
 * @module api/web-multiclient
 *
 * @example
 * import { webMulticlientAPI } from '~/api/web-multiclient';
 */
export const webMulticlientAPI = {
    /**
     * the API endpoint path
     * @constant path
     * @private
     */
    path: '/web/multiclient',
    /**
     * Places a GET /web/multiclient request with the given client ids
     * as query parameters. Client ids are optional.
     * @method get
     * @static
     * @param clientIds
     * @return {Promise<never>|Promise<AxiosResponse<any>>}
     *
     * @example
     * const getWebMulticlient = async (activeClientIds) => {
     *     try {
     *         await webMulticlientAPI.get(activeClientIds);
     *     } catch (err) {
     *         console.error('Failed to get web messages:', err);
     *     }
     * };
     */
    get(clientIds) {
        const params = {};
        if (clientIds && clientIds.length) {
            if (!Array.isArray(clientIds)) {
                return Promise.reject('clientIds must be an array');
            }
            params.client_ids = clientIds;
        }
        return axios.get(this.path, {
            params
        });
    }
};
